import { LOGOUT } from "../store/actions/authenticationAction"

const separateFaceIdType = function () {
    try {
        const centerId = JSON.parse(localStorage.getItem("centerId")).centerId

        switch (centerId) {
            //!kasnazan, chwarchra
            case "66bdca9b7add38fef2918d63":
            case '62d3de0de4b5f62ba339b22d': {
                return 0
            }
            //!asuda
            case '62d3de11e4b5f62ba339b22f': {
                return 1
            }
            //slava mini slava parosh
            case '63f38ea7cb9593c58e562b6d':
            case '63f38eb3cb9593c58e562b75':
            case '63f38ec4cb9593c58e562b77':
            case '63f38ed4cb9593c58e562b79':
            case '63f48ae929c35a4c83cdc37c':
            case '65056978310b44af35de66c9': {
                return 2
            }
            default: { return -1 }
        }
    } catch (e) {
        // alert('error centerId')
        // LOGOUT()
        console.log(e)
    }
    //! Separate FaceIds By Centers

}


export default separateFaceIdType